import script from "./GroupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupForm.vue?vue&type=script&setup=true&lang=js"

import "./GroupForm.vue?vue&type=style&index=0&id=1f318fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f318fd0"]])

export default __exports__